import { render, staticRenderFns } from "./ComunaCrear.vue?vue&type=template&id=0a0a7723"
import script from "./ComunaCrear.vue?vue&type=script&lang=js"
export * from "./ComunaCrear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports